<template>
<div class="index">
    <vtop /> 
    <router-view />
    <vfooter />
</div>   
</template>
<script>
import vtop from './index_top'
import vcontent from './index_content'
import vfooter from './index_footer'

export default {
    components: {
        vtop,
        vfooter,
    }
}
</script>

<style lang="stylus" scoped>
@import "~styl/mixin.styl"
.index
    min-width 1200px
</style>


// WEBPACK FOOTER //
// src/components/index/index.vue